import request, { gql } from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";

const createquotationstatus = gql`
  mutation createquotationstatus($input: CreateQuatationStatusInput!) {
    createQuotationstatus(input: $input) {
      set
    }
  }
`;

export const addQuoteService = async (values) => {
  let status = false;
  try {
    const res = request(BASEURL, createquotationstatus, {
      input: values,
    });
    status = true;
  } catch (err) {}

  return status;
};
